<script setup>
import { motion, AnimatePresence } from "motion-v";
import { useDevice } from "~/composables/useDevice";

const { isMobile } = useDevice();

const isActive = ref(false);
const navRef = ref(null);
const route = useRoute();

const showMenu = computed(() => !isMobile.value || isActive.value);

const currentLabel = computed(() => {
  const path = route.path;
  if (path.startsWith("/mypage/billing")) return "입/출금";
  if (path.startsWith("/mypage/history")) return "배팅내역";
  return "프로필";
});

const currentIcon = computed(() => {
  const path = route.path;
  if (path.startsWith("/mypage/billing")) return "ico-prefix";
  if (path.startsWith("/mypage/history")) return "ico-history";
  return "ico-user-thin";
});

const handleOutsideClick = (event) => {
  if (!isMobile.value) return;
  const navEl = navRef.value;
  if (!navEl) return;

  if (!navEl.contains(event.target)) {
    isActive.value = false;
  }
};

onMounted(() => {
  if (typeof window !== "undefined") {
    window.addEventListener("click", handleOutsideClick);
  }
});

onBeforeUnmount(() => {
  if (typeof window !== "undefined") {
    window.removeEventListener("click", handleOutsideClick);
  }
});

watch(
  () => route.fullPath,
  () => {
    if (isMobile.value) {
      isActive.value = false;
    }
  }
);

// 네비게이션 메뉴 애니메이션 설정 함수
const getNavMenuAnimation = () => ({
  initial: {
    height: 0,
    opacity: 0,
  },
  animate: {
    height: "auto",
    opacity: 1,
  },
  exit: {
    height: 0,
    opacity: 0,
  },
  transition: {
    height: {
      duration: 0.28,
      ease: [0.22, 0.61, 0.36, 1],
    },
    opacity: {
      duration: 0.22,
      ease: [0.22, 0.61, 0.36, 1],
    },
  },
});
</script>

<template>
  <nav ref="navRef" class="mypage__nav" :class="{ active: showMenu }">
    <div class="mypage__nav-title">
      <button
        type="button"
        class="mypage__nav-btn ico-after ico-down-thin"
        @click="isActive = !isActive"
      >
        <i :class="currentIcon"></i>
        {{ currentLabel }}
      </button>
    </div>
    <AnimatePresence>
      <motion.ul
        v-if="showMenu"
        key="nav-menu"
        class="mypage__nav-menu"
        :initial="getNavMenuAnimation().initial"
        :animate="getNavMenuAnimation().animate"
        :exit="getNavMenuAnimation().exit"
        :transition="getNavMenuAnimation().transition"
        style="overflow: hidden"
      >
        <li class="mypage__nav-item">
          <NuxtLink
            to="/mypage"
            class="mypage__nav-link ico-before ico-user-thin"
            active-class="active"
            exact
            >프로필</NuxtLink
          >
        </li>
        <li class="mypage__nav-item">
          <NuxtLink
            to="/mypage/billing"
            class="mypage__nav-link ico-before ico-prefix"
            active-class="active"
            >입/출금</NuxtLink
          >
        </li>
        <li class="mypage__nav-item">
          <NuxtLink
            to="/mypage/history"
            class="mypage__nav-link ico-before ico-history"
            active-class="active"
            >배팅내역</NuxtLink
          >
        </li>
      </motion.ul>
    </AnimatePresence>
  </nav>
</template>

<style scoped>
</style>
